/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright':
    'Mogelijk gemaakt door Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Aangedreven door AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'De inhoud is gebaseerd op je rechten en de kwaliteit kan variëren',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'De kwaliteit van de inhoud kan verschillen',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': 'Maakt gebruik van AI. Controleer de resultaten.',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informatie',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Kennis uit huidige pagina opnemen',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Terug',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Annuleren',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Annuleren',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Annuleren',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Fout antwoord',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback verstuurd',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Goed antwoord',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Doorgaan vanaf laatste reactie',
  'fabric.editor.ai.config.item.action.copyResponse': 'Kopiëren',
  'fabric.editor.ai.config.item.action.responseCopied': 'Gekopieerd!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Gekopieerd naar klembord',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Opnieuw proberen',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Er gaat aan onze kant iets niet goed bij het invoeren van de reactie. Sluit het dialoogvenster en probeer het opnieuw.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'We konden geen reactie krijgen. Je prompt of reactie was boven de limiet voor deze aanvraag. Sluit het dialoogvenster en probeer het opnieuw.',
  'fabric.editor.ai.experience.apiError': 'We kregen geen reactie, probeer het opnieuw',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.commandPaletteV2Placeholder': 'Vertel wat AI moet doen ...',
  'fabric.editor.ai.experience.inputTooShortError':
    'De inhoud is te kort om samen te vatten. Voeg meer inhoud toe en probeer het dan nogmaals.',
  'fabric.editor.ai.experience.loadingAriaNewTitle': 'Rovo is aan het werk',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Genereren',
  'fabric.editor.ai.experience.loadingEditingTitle': 'Rovo is aan het bewerken',
  'fabric.editor.ai.experience.previewScreenLabel': 'Voorvertoning',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Typ wat de Agent moet schrijven of selecteer hieronder een prompt',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo-logo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Vorige',
  'fabric.editor.ai.screens.discard.discardLabel': 'Wissen',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Waarschuwing',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Fout',
  'fabric.editor.ai.screens.error.cancelLabel': 'Annuleren',
  'fabric.editor.ai.screens.error.retryLabel': 'Opnieuw proberen',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Live bijwerkende content:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Pictogram genereren',
  'fabric.editor.ai.screens.noImprovement.closeLabel': 'Sluiten',
  'fabric.editor.ai.screens.noImprovement.noImprovementMessage': 'Geen verbeteringen, goed werk.',
  'fabric.editor.ai.screens.noImprovement.successIconLabel': 'Gelukt',
  'fabric.editor.ai.screens.preview.actionButtonsAccept': 'Accepteren',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': 'Actie voor door AI gegenereerde inhoud',
  'fabric.editor.ai.screens.preview.actionButtonsTryAgain': 'Opnieuw proberen',
  'fabric.editor.ai.screens.preview.betaLabel': 'Bèta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Annuleren',
  'fabric.editor.ai.screens.preview.compactFeedbackText': 'Nuttig?',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Vertel wat AI nu moet doen',
  'fabric.editor.ai.screens.preview.discardLabel': 'Wissen',
  'fabric.editor.ai.screens.preview.disclaimer': 'De kwaliteit van de informatie kan verschillen.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Lees hier waarom',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Wissen',
  'fabric.editor.ai.screens.preview.header.edit': 'Prompt bewerken',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Bewerken',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Vraag {agentName} wat je nu moet doen',
  'fabric.editor.ai.screens.preview.refineButton': 'Verfijnen',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Verfijnen',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink': 'Link toevoegen',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention': 'Gebruiker vermelden',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel': 'Opgemaakte inhoud toevoegen',
  'fabric.editor.ai.screens.prompt.streaming.placeholder': 'Beschrijf wat je wilt doen',
  'fabric.editor.ai.screens.prompt.streaming.record': 'Opnemen',
  'fabric.editor.ai.screens.prompt.streaming.submit': 'Verzenden',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Indienen',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Sturen naar AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} - Geselecteerd',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Verwijderen',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Suggesties',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Schrijfassistent',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Laat Atlassian Intelligence je helpen met schrijven',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Schrijven',
  'fabric.editor.ai.shared.betaLabel': 'Bèta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BÈTA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NIEUW',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'AI inlichten',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Zeg tegen de agent:',
};
